import {
  Box,
  Button,
  Flex,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
  useToast,
} from "@chakra-ui/react";
import React from "react";
import program_moduleService from "../../../services/program_service/program_module.service";

export const DeleteProgramModuleModal: React.FC<any> = ({
  moduleId,
  isOpenDelete,
  onCloseDelete,
  updateRecord,
}: {
  moduleId: string;
  isOpenDelete: any;
  onCloseDelete: any;
  updateRecord: any;
}) => {
  const toast = useToast();

  const handleDeleteCourse = async (moduleId: string) => {
    try {
      const deleteCourse = await program_moduleService.deleteModuleById(moduleId);
      if (deleteCourse.status == 'success') {
        onCloseDelete();
        updateRecord();
        toast({
          title: "Delete Module",
          description: "Module deleted successfully",
          status: "success",
        });
      }
      else {
        toast({
          title: "Delete Module",
            description: `${deleteCourse.message}`,
            status: "error",
        });
    }
    } catch (error :any) {
      toast({
        title: "Delete Module",
        description: `${error.response.data.message}`,
        status: "error",
      });
    }
  };

  return (
    <>
      <Modal
        isOpen={isOpenDelete}
        onClose={onCloseDelete}
        scrollBehavior="outside"
        closeOnOverlayClick={true}
        size="md"
        isCentered
      >
        <ModalOverlay />
        <ModalContent borderRadius={5} px={3}>
          <ModalHeader>
            <Flex justifyContent="center">
              <Box>
                <Flex justifyContent="center">
                  <Text
                    mx="auto"
                    color="#353535"
                    fontSize="22px"
                    fontWeight="800"
                  >
                    Delete Module
                  </Text>
                </Flex>
              </Box>
            </Flex>
          </ModalHeader>
          <ModalCloseButton size="sm" />
          <ModalBody>
            <VStack>
              <Text fontWeight={"700"} fontSize="16px">
                Are you sure you want to delete this module ?
              </Text>
              <HStack
                gap="1rem"
                fontSize="13px"
                justifyContent={"flex-end"}
                width={"100%"}
                paddingY={"1rem"}
              >
                <Button
                  onClick={() => handleDeleteCourse(moduleId)}
                  colorScheme="red"
                  borderRadius={"none"}
                >
                  Delete
                </Button>
                <Button borderRadius={"none"} onClick={onCloseDelete}>
                  Exit
                </Button>
              </HStack>
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
